import {JsonPipe} from '@angular/common';
import {Component, computed, input} from '@angular/core';
import {IackathonSave} from '../../../../services/iackathon-saves.service';

@Component({
  selector: 'app-iackathon-step-rating-others',
    imports: [
        JsonPipe
    ],
  templateUrl: './iackathon-step-rating-others.component.html',
  styleUrl: './iackathon-step-rating-others.component.scss',
})
export class IackathonStepRatingOthersComponent {
    save = input.required<IackathonSave>();
    private state = computed(() => this.save().attributes.content.state);
    protected ratingOthers = computed(() => this.state().groups_project_reviews);
    protected otherGroups = computed(() => Object.keys(this.ratingOthers() || {}));

}
